module.exports = __webpack_public_path__ + "img/login-v2-dark.ef74233e.svg";